import React from 'react';
import { Layers, Move, PaintBucket } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { services } from '../data/mockData';

const iconMap = {
  Layers: Layers,
  Stairs: Move,
  PaintBucket: PaintBucket
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-[#F5EFE6]/30">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-[#F5EFE6] rounded-full mb-4">
            <span className="text-[#8B7355] font-semibold text-sm">Nos Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Notre expertise à votre service
          </h2>
          <p className="text-lg text-gray-600">
            Des prestations complètes pour tous vos travaux de revêtement et finitions
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-500 border-0 bg-white overflow-hidden"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className={`w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 ${
                      service.id === 1 ? 'object-bottom' : ''
                    }`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  
                  {/* Icon Badge */}
                  <div className="absolute top-4 right-4 w-12 h-12 bg-[#8B7355] rounded-xl flex items-center justify-center group-hover:rotate-12 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                </div>

                <CardContent className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#8B7355] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Decorative Line */}
                  <div className="mt-6 pt-4 border-t border-gray-100">
                    <div className="w-12 h-1 bg-gradient-to-r from-[#C9A961] to-[#8B7355] rounded-full group-hover:w-full transition-all duration-500"></div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 text-lg">
            Un projet en tête ? 
            <a 
              href="tel:0650088282" 
              className="text-[#8B7355] font-semibold hover:text-[#6B5744] ml-2 underline underline-offset-4"
            >
              Contactez-nous
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
